import { Box, CircularProgress } from "@mui/material";

interface RouteFallbackProps {
  label?: string;
}

/**
 * Centered spinner shown while a lazily loaded route chunk arrives or the auth
 * session resolves.
 */
export default function RouteFallback({ label = "Loading" }: Readonly<RouteFallbackProps>) {
  return (
    <Box
      sx={{
        // Fills the layout's main area rather than forcing 100vh, which would
        // overflow when the app header is visible.
        flex: 1,
        minHeight: 0,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
      }}
    >
      <CircularProgress size={40} aria-label={label} />
    </Box>
  );
}
